// Estos son los datos para enviar un correo electronico en produccion
export const API = 'https://us-central1-booking-t49.cloudfunctions.net/emailnotification/';
export const APIARRAY = 'https://us-central1-booking-t49.cloudfunctions.net/emailnotificationarray/';
export const APINOPDF = 'https://us-central1-booking-t49.cloudfunctions.net/notificationemailnopdf/';

// Estos son los datos para enviar un correo electronico en local
// export const API = 'http://localhost:3001/';